const BASE_URL = 'https://dotteckhub.com/test/public'; // Update this if your PHP server runs on a different URL

export const api = {
    // Customers
    getCustomers: async () => {
        try {
            const res = await fetch(`${BASE_URL}/karyana/customers`);
            return await res.json();
        } catch (error) {
            console.error("Error fetching customers:", error);
            return [];
        }
    },
    addCustomer: async (customer) => {
        try {
            const res = await fetch(`${BASE_URL}/karyana/customers/add`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(customer)
            });
            return await res.json();
        } catch (error) {
            console.error("Error adding customer:", error);
            return { error: true };
        }
    },
    deleteCustomer: async (id) => {
        try {
            const res = await fetch(`${BASE_URL}/karyana/customers/delete`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id })
            });
            return await res.json();
        } catch (error) {
            console.error("Error deleting customer:", error);
            return { error: true };
        }
    },

    // Products
    getProducts: async () => {
        try {
            const res = await fetch(`${BASE_URL}/karyana/products`);
            return await res.json();
        } catch (error) {
            console.error("Error fetching products:", error);
            return [];
        }
    },
    addProduct: async (product) => {
        try {
            const res = await fetch(`${BASE_URL}/karyana/products/add`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(product)
            });
            return await res.json();
        } catch (error) {
            console.error("Error adding product:", error);
            return { error: true };
        }
    },
    deleteProduct: async (id) => {
        try {
            const res = await fetch(`${BASE_URL}/karyana/products/delete`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id })
            });
            return await res.json();
        } catch (error) {
            console.error("Error deleting product:", error);
            return { error: true };
        }
    },
    updateProduct: async (product) => {
        try {
            const res = await fetch(`${BASE_URL}/karyana/products/update`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(product)
            });
            return await res.json();
        } catch (error) {
            console.error("Error updating product:", error);
            return { error: true };
        }
    },

    // Orders
    addOrder: async (order) => {
        try {
            const res = await fetch(`${BASE_URL}/karyana/orders/add`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(order)
            });
            return await res.json();
        } catch (error) {
            console.error("Error adding order:", error);
            return { error: true };
        }
    },
    getOrders: async () => {
        try {
            const res = await fetch(`${BASE_URL}/karyana/orders`);
            return await res.json();
        } catch (error) {
            console.error("Error fetching orders:", error);
            return [];
        }
    },
    getOrderDetails: async (id) => {
        try {
            const res = await fetch(`${BASE_URL}/karyana/orders/${id}`);
            return await res.json();
        } catch (error) {
            console.error("Error fetching order details:", error);
            return [];
        }
    },
    deleteOrder: async (id) => {
        try {
            const res = await fetch(`${BASE_URL}/karyana/orders/delete`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id })
            });
            return await res.json();
        } catch (error) {
            console.error("Error deleting order:", error);
            return { error: true };
        }
    },
    updateOrder: async (order) => {
        try {
            const res = await fetch(`${BASE_URL}/karyana/orders/update`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(order)
            });
            return await res.json();
        } catch (error) {
            console.error("Error updating order:", error);
            return { error: true };
        }
    }
};
